import { View } from 'ckeditor5/src/ui';
import '../theme/emojiinfo.css';
/**
 * The view displaying detailed information about a emoji glyph, e.g. upon
 * hovering it with a mouse.
 */
export default class EmojiInfoView extends View {
    constructor(locale) {
        super(locale);
        const bind = this.bindTemplate;
        this.set('emoji', null);
        this.set('name', null);
        this.bind('code').to(this, 'emoji', emojiToUnicodeString);
        this.setTemplate({
            tag: 'div',
            children: [
                {
                    tag: 'span',
                    attributes: {
                        class: [
                            'ck-emoji-info__name'
                        ]
                    },
                    children: [
                        {
                            // Note: ZWSP to prevent vertical collapsing.
                            text: bind.to('name', name => name ? name : '\u200B')
                        }
                    ]
                },
                {
                    tag: 'span',
                    attributes: {
                        class: [
                            'ck-emoji-info__code'
                        ]
                    },
                    children: [
                        {
                            text: bind.to('code')
                        }
                    ]
                }
            ],
            attributes: {
                class: [
                    'ck',
                    'ck-emoji-info'
                ]
            }
        });
    }
}
/**
 * Converts a emoji into a "Unicode string", for instance:
 *
 * "$" -> "U+0024"
 *
 * Returns an empty string when the emoji is `null`.
 */
function emojiToUnicodeString(emoji) {
    if (emoji === null) {
        return '';
    }
    const hexCode = emoji.codePointAt(0).toString(16);
    return 'U+' + ('0000' + hexCode).slice(-4);
}
